<template>
  <div class="col-sm-12 col-md-4">
    <div class="card" style="width: 18rem;">
      <img
        :src="product.image"
        class="card-img-top"
        alt="..."
        style="width: 100%; height: 200px; object-fit: cover;"
      />
      <div class="card-body">
        <h5 class="card-title" style="cursor: pointer;">{{ product.name }}</h5>
        <span class="card-link">
          <i class="fas fa-map-marker-alt" />
          {{ product.community }}
        </span>
        <span class="card-link">
          <i class="fa fa-eye" />
          {{ product.threshhold }}
        </span>
        <span class="card-link">
          <i class="fas fa-truck" />
          {{ product.quantity }}
        </span>
        <span
          class="card-link"
          data-toggle="tooltip"
          :title="`${translate('product_box.will_be_ready_in')} ${product.completion_days} ${translate('product_box.days')}`"
        >
          <i class="fas fa-calendar-check" />
          {{ product.completion_days }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductBoxSm",
  props: {
    product: {
      required: true,
      type: Object
    },
    design: {
      default: 1,
      type: Number
    }
  }
};
</script>

<style scoped lang="scss">
.card-link {
  color: grey;
}
</style>
